export default __webpack_public_path__ + "static/box-img-bd39d92a9165a43ccea99aaa992a3362.png";